import { motion } from "framer-motion";
import { useEffect } from "react";
import { createPortal } from "react-dom";

const framerSidebarBackground = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0, transition: { delay: 0.1 } },
  transition: { duration: 0.3 },
};

export function PopupModal({
  onClose,
  children,
  contentClassName = "",
  overlayClassName = "",
  exit = { opacity: 0, transition: { delay: 0.1 } },
  shouldStopPropagation = true,
}: {
  onClose?: () => void;
  children: React.ReactNode;
  contentClassName?: string;
  overlayClassName?: string;
  exit?: any;
  shouldStopPropagation?: boolean;
}) {
  const handleClose = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onClose && onClose();
  };

  const disableScroll = () => {
    document.body.style.overflow = "hidden";
  };

  const enableScroll = () => {
    document.body.style.overflow = "";
  };

  useEffect(() => {
    disableScroll();
    return () => enableScroll();
  }, []);

  return createPortal(
    <div className="fixed z-[70] top-0 left-0 right-0 bottom-0 h-[100dvh] flex flex-col justify-center">
      <motion.div
        data-testid="popup-modal-backdrop"
        className={`fixed z-[71] top-0 left-0 right-0 bottom-0 bg-black/40 h-[100dvh] ${overlayClassName}`}
        onClick={handleClose}
        {...{ ...framerSidebarBackground, exit }}
      />
      <motion.div
        className={`p-8 bg-surface-primary rounded-xl relative flex-col gap-6 flex z-[72] ${contentClassName}`}
        {...{ ...framerSidebarBackground, exit }}
        onClick={(e) => {
          if (shouldStopPropagation) {
            e.stopPropagation();
            e.preventDefault();
          }
        }}
      >
        {children}
      </motion.div>
    </div>,
    document.body,
  );
}
